import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Font, ColorEnvironment, Flexbox } from './Styles';

const styles = StyleSheet.create({
  container: {
    marginLeft: 10,
    marginRight: 10
  },
  circle: {
    height: 88,
    width: 88,
    marginBottom: 5,
    borderRadius: '100%',
    '@media (max-width: 320px)': {
      height: 60,
      width: 60
    }
  },
  text: {
    '@media (max-width: 320px)': {
      fontSize: '80%'
    }
  },
  small: {
    fontSize: '66%'
  }
});

class CostComponent extends Component {
  render() {
    var prefix = (this.props.value > 0)? "+" : ((this.props.value < 0)? "-" : "");
    prefix += this.props.prefix || "";
    let string = `${prefix}${Math.abs(this.props.value)}`;

    return(
      <div className={css(styles.container, Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(styles.circle, ColorEnvironment.inverse)}>
          <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical)}>
            <div className={css(Font.heading, styles.text, string.length > 4? styles.small : null)}>{string}</div>
          </div>
        </div>
        <div className={css(Font.label)}>{this.props.label}</div>
      </div>
    );
  }
}

export default CostComponent;



// WEBPACK FOOTER //
// ./src/CostComponent.js